import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { Modal } from "./Modal";

export type SuccessModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message: React.ReactNode;
  icon?: IconProp;
  maxWidth?: "sm" | "md" | "lg" | "xl";
};

export const SuccessModal = ({
  isOpen,
  onClose,
  title = "Succès",
  message,
  icon = "check-circle",
  maxWidth = "sm",
}: SuccessModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      icon={icon}
      maxWidth={maxWidth}
    >
      <div className="text-center space-y-3 leading-relaxed">
        <div className="text-tertiary font-oxaniumMedium">{message}</div>
      </div>
    </Modal>
  );
};
